import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { basePathConfig } from "../../config";
import errorHandler from "../error/errorHandler";

// Thunks
export const mapAgentToLocation = createAsyncThunk(
  "agentLocationMapping/map",
  async (payloadData) => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");
      const payload = {
        account_id: accountID,
        agent_id: payloadData.agent_ids,
        sticky_location_id: payloadData.location_id,
      };
      console.log("Payload", payloadData);

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.post(
          `${basePathConfig.baseURL}/app/sticky-location-agent`,
          payload,
          config
        );

        return await res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);

export const fetchAgentLocationMappings = createAsyncThunk(
  "agentLocationMapping/fetch",
  async () => {
    try {
      const bearer_token = `Bearer ${localStorage.getItem("accessToken")}`;
      const accountID = localStorage.getItem("atua");

      if (!!bearer_token && !!accountID) {
        const config = {
          headers: {
            Authorization: bearer_token,
          },
        };

        const res = await axios.get(
          `${basePathConfig.baseURL}/app/sticky-location-agent/account/${accountID}`,
          config
        );

        return await res.data;
      } else {
        return { message: "Unauthorized", status: 401 };
      }
    } catch (error) {
      var ErrorData = await errorHandler(error);
      return await ErrorData;
    }
  }
);

export const hardDeleteAgentLocationMapping = createAsyncThunk(
  "agentLocationMapping/hardDelete",
  async ({ mappingId, agentId }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${basePathConfig.baseURL}/app/sticky-location-agent/${mappingId}`,
        {
          agent_id: agentId, // This will be bodyData.agent_id in backend
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return {
        ...response.data.data,
        mappingId, // manually add it so reducer can use it
      }; // or mappingId if you want to remove it from UI
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Agent location removal failed"
      );
    }
  }
);

// Initial state
const initialState = {
  mapAgentToLocationData: {
    data: {},
    status: "",
    error: {},
  },
  fetchAgentLocationMappingsData: {
    data: [],
    status: "",
    error: {},
  },
  hardDeleteAgentLocationMappingData: {
    data: {},
    status: "",
    error: {},
  },
};

// Create slice
export const agentLocationMappingSlice = createSlice({
  name: "agentLocationMapping",
  initialState,
  reducers: {
    resetAgentLocationMapping: () => initialState,
    resetMapAgentToLocationData: (state) => {
      state.mapAgentToLocationData = {
        data: {},
        status: "",
        error: {},
      };
    },
    resetHardDeleteAgentLocationMappingData: (state) => {
      state.hardDeleteAgentLocationMappingData = {
        data: {},
        status: "",
        error: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // Map Agent To Location
      .addCase(mapAgentToLocation.pending, (state) => {
        state.mapAgentToLocationData = {
          status: "loading",
          data: {},
          error: {},
        };
      })
      .addCase(mapAgentToLocation.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.mapAgentToLocationData = {
            status: "failed",
            data: {},
            error: action.payload.error,
          };
        } else {
          state.mapAgentToLocationData = {
            status: "succeeded",
            data: action.payload,
            error: {},
          };
        }
      })
      .addCase(mapAgentToLocation.rejected, (state, action) => {
        state.mapAgentToLocationData = {
          status: "failed",
          data: {},
          error: action.payload,
        };
      })

      // Fetch Agent Location Mappings
      .addCase(fetchAgentLocationMappings.pending, (state) => {
        state.fetchAgentLocationMappingsData = {
          status: "loading",
          data: [],
          error: {},
        };
      })
      .addCase(fetchAgentLocationMappings.fulfilled, (state, action) => {
        console.log("Fetched agent location mappings data:", action.payload);

        if (action.payload.error) {
          state.fetchAgentLocationMappingsData = {
            status: "failed",
            data: [],
            error: action.payload.error,
          };
        } else {
          state.fetchAgentLocationMappingsData = {
            status: "succeeded",
            data: action.payload,
            error: {},
          };
        }
      })
      .addCase(fetchAgentLocationMappings.rejected, (state, action) => {
        state.fetchAgentLocationMappingsData = {
          status: "failed",
          data: [],
          error: action.payload,
        };
      })

      // Hard Delete Agent Location Mapping
      .addCase(hardDeleteAgentLocationMapping.pending, (state) => {
        state.hardDeleteAgentLocationMappingData = {
          status: "loading",
          data: {},
          error: {},
        };
      })
      .addCase(hardDeleteAgentLocationMapping.fulfilled, (state, action) => {
        // const { mappingId } = action.payload;
        if (action.payload.error) {
          state.hardDeleteAgentLocationMappingData = {
            status: "failed",
            data: {},
            error: action.payload.error,
          };
        } else {
          // Update fetchAgentLocationMappingsData by removing the deleted mapping
          // state.fetchAgentLocationMappingsData.data =
          //   state.fetchAgentLocationMappingsData.data.filter(
          //     (m) => m._id !== mappingId
          //   );

          state.hardDeleteAgentLocationMappingData = {
            status: "succeeded",
            data: action.payload,
            error: {},
          };
        }
      })
      .addCase(hardDeleteAgentLocationMapping.rejected, (state, action) => {
        state.hardDeleteAgentLocationMappingData = {
          status: "failed",
          data: {},
          error: action.payload,
        };
      });
  },
});

// Export actions and reducer
export const {
  resetAgentLocationMapping,
  resetMapAgentToLocationData,
  resetHardDeleteAgentLocationMappingData,
} = agentLocationMappingSlice.actions;
export default agentLocationMappingSlice.reducer;
